import wixLocation from 'wix-location';
import wixWindow from 'wix-window';
// import { biLoggerFactory } from 'wix-private';
import { getLoggedInUser } from 'public/users.js'

// const biLogger = biLoggerFactory('lp', 19, { msid: '3cdc5f9e-029c-4e4d-8bc6-da2cb1cac486' });
// const biLoggerPages = biLoggerFactory('pblc', 19, { msid: '3cdc5f9e-029c-4e4d-8bc6-da2cb1cac486' });

let url = 'https://www.wix.com/account/sites'

$w.onReady(function () {
	if (wixWindow.rendering.env !== "browser") {
		return;
	}
	getLoggedInUser().then(success => {
		console.log('SUCCESS: ', success)
		if (success) {
			url = 'https://www.wix.com/account/sites'
		} else {
			url = 'https://users.wix.com/signin?utm_campaign=communitysite'
		}
		$w('#button12').link = url
		$w('#button12').target='_blank'
	});
	// if (wixWindow.formFactor === "Desktop") {
	// 	$w('#box1').onClick(async () => {
	// 		console.log('in click event')
	// 		try {
	// 			const biEventObject = { evid: 703, button_name: 'StartNow', is_valid: true, topic: 'Partners Minisite', url: wixLocation.url };
	// 			await biLogger.log(biEventObject);
	// 		} catch (err) {
	// 			console.log(err, "heree")
	// 		}
	// 		// wixLocation.to(url)
		
	// 		// $w('#html1').postMessage(url)
	// 	})
	// }
});
